<template>
  <div>
    <div v-for="(item, index) in dataSource" :key="index">
      <div class="topic">{{ item.name }}</div>
      <div class="select-area">
        <a-radio-group
          v-for="(optItem, optIndex) in item.schoolEvaluationAnswerOptionsList"
          :key="optIndex"
          v-model="selectMode[index]"
          @change="onChange"
        >
          <a-radio :value="`${optItem.id},${optItem.score}`">{{ optItem.name }}</a-radio>
        </a-radio-group>
      </div>
    </div>
    <!-- <span v-for="(item, index) in selectMode" :key="index">{{ item }}</span> -->
    <!--<div>选项：[{{ selectMode.join(', ') }}]</div>-->
  </div>
</template>

<script>
export default {
  name: 'QuesPreview',
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableData: [],
      selectMode: [],
    }
  },
  components: {},
  created() {
    // this.getQuesList();
  },
  methods: {
    getQuesList() {
      console.log('问卷数据：', quesTableList)
      this.tableData = quesTableList
    },
    onChange(e) {},
  },
}
</script>
<style scoped lang="less">
.topic {
  font-size: 14px;
  line-height: 20px;
}
.select-area {
  margin: 20px;
}
</style>
